export const LANGUAGES = [
  { value: "English", label: "English" },
  { value: "Spanish", label: "Español" },
  { value: "French", label: "Français" },
  { value: "Portuguese", label: "Português" },
  { value: "Hindi", label: "हिन्दी" },
  { value: "Swahili", label: "Kiswahili" },
  { value: "Arabic", label: "العربية" },
  { value: "Chinese", label: "中文" },
  { value: "Indonesian", label: "Bahasa Indonesia" },
];
